import { useEffect } from 'react';
import { useAuth } from '../auth/AuthContext.tsx';
import { initJiraExtensionRelay, teardownJiraExtensionRelay } from './extensionRelay.ts';

/**
 * Поднимает доступ к Jira «через браузер» (расширение Lens), когда пользователь
 * авторизован, и гасит канал при выходе. В token-режиме ничего не делает.
 * Рендерит null — это только сайд-эффект жизненного цикла сессии.
 */
export function JiraRelayBootstrap(): null {
  const { status } = useAuth();
  useEffect(() => {
    if (status === 'authenticated') {
      void initJiraExtensionRelay();
    } else if (status === 'anonymous') {
      teardownJiraExtensionRelay();
    }
  }, [status]);
  return null;
}
